import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProductDTO} from '../models/ProductDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private url = environment.baseUrl + '/product';

  constructor(private httpClient: HttpClient) {
  }

  getInsuredPersonLinkedProducts(insuredPersonId: number, policyId?: number, processingClassId?: number): Observable<ProductDTO[]> {

    let params = new HttpParams();

    if (policyId != null) {
      params = params.set('insuredPersonId', String(insuredPersonId));
      params = params.set('policyId', String(policyId));
    }
    else if (processingClassId != null) {
      params = params.set('insuredPersonId', String(insuredPersonId));
      params = params.set('processingClassId', String(processingClassId));
    }
    else {
      params = params.set('insuredPersonId', String(insuredPersonId));
    }

    return this.httpClient.get<ProductDTO[]>(this.url, {params});
  }

  getPolicyLinkedProducts(policyId: number): Observable<ProductDTO[]> {
    let params = new HttpParams();
    params = params.set('policyId', String(policyId));

    return this.httpClient.get<ProductDTO[]>(this.url + '/by-policy', {params});
  }

  getProductByProductId(productId: number): Observable<ProductDTO> {
    return this.httpClient.get<ProductDTO>(`${this.url}/${productId}`);
  }

  getListOfProducts(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ProductDTO>> {
    return this.httpClient.post<PagedResponseDTO<ProductDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  deleteProduct(productId: number) {
    return this.httpClient.delete<{}>(this.url + '/' + productId);
  }

  saveProduct(productPayload: ProductDTO): Observable<ProductDTO> {
    return this.httpClient.post<ProductDTO>(`${this.url}`, productPayload);
  }
}
